<template>
  <div>
    <div class="searchDiv">
      <el-row :gutter="20">
        <!-- 第一行：四个控件+查询按钮 -->
        <el-col :span="5">
          <el-input class="w-full" v-model="params.customerName" placeholder="客户姓名" clearable/>
        </el-col>
        <el-col :span="5">
          <el-input class="w-full" v-model="params.orderNo" placeholder="订单编号" clearable/>
        </el-col>
        <el-col :span="5">
          <el-select class="w-full" v-model="params.platformId" clearable @change="getProductList()"
                     placeholder="请选择资金平台">
            <el-option v-for="(item, index) in platformList" :key="index" :label="item.name"
                       :value="parseInt(item.id)"/>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select class="w-full" v-model="params.productId" clearable placeholder="请选择产品">
            <el-option v-for="(item, index) in productList" :key="index" :label="item.name" :value="parseInt(item.id)"/>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mt-4">
        <!-- 第二行：四个过滤条件 -->
        <el-col :span="5">
          <el-select class="w-full" v-model="params.status" clearable placeholder="订单状态">
            <el-option v-for="item in $dict.map['order_status']" :key="item.value" :label="item.name"
                       :value="item.value"/>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-date-picker
              class="w-full"
              v-model="createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
          />
        </el-col>
        <el-col :span="5">
          <el-cascader
              class="w-full"
              v-model="params.department"
              :options="options"
              :props="{
                checkStrictly: true,
                expandTrigger: 'hover',
                value: 'code',
                label: 'name',
                children: 'children'
              }"
              placeholder="归属"
              @change="handleChange"
              clearable
          />
        </el-col>
        <el-col :span="5">
          <el-input class="w-full" v-model="params.salesmanName" placeholder="业务员" clearable/>
        </el-col>
        <el-col :span="4" class="flex justify-end">
          <el-button type="primary" @click="getPageList">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-container">
    <el-table :data="tableData" row-key="id" border >
      <el-table-column label="客户姓名" prop="customerName"></el-table-column>
      <el-table-column label="订单编号" prop="orderNo" width="160px"></el-table-column>
      <el-table-column label="大区" prop="region" width="100px"></el-table-column>
      <el-table-column label="所属门店" prop="department" width="160px"></el-table-column>
      <el-table-column label="所属团队" prop="teamName" width="100px"></el-table-column>
      <el-table-column label="所属销售" prop="salesmanName" width="100px"></el-table-column>
      <el-table-column label="资金平台" prop="fundPlatform" width="80px"></el-table-column>
      <el-table-column label="产品名称" prop="productName" width="150px"></el-table-column>
      <el-table-column label="进件时间" prop="createTime" width="140px"></el-table-column>
      <el-table-column label="批复时间" prop="threeAuditTime" width="140px"></el-table-column>
      <el-table-column label="放款时间" prop="lendingTime" width="140px"></el-table-column>
      <el-table-column label="申请金额" prop="applyMoney" width="90px"></el-table-column>
      <el-table-column label="批复金额" prop="approveAmount" width="90px"></el-table-column>
      <el-table-column label="批复期数" prop="duration" width="70px"></el-table-column>
      <el-table-column label="节点状态" prop="statusName" width="100px"></el-table-column>
      <el-table-column label="备注" prop="auditContent"></el-table-column>
      <el-table-column label="操作" prop="option" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('order:look')" type="info" @click="viewRow(JSON.parse(JSON.stringify(scope.row)))">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="params.current" :size.sync="params.size" :total="params.total"
                @get-list="getPageList"></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import {hasPer} from "@/utils/common";
import store from "@/store";
import {getOrderList} from "@/api/order/order";
import {getPlatformList} from "@/api/prod/platform/platform";
import {getProductList} from "@/api/prod/product/product";
import {getPositionsTree} from "@/api/sys/positions/sysPositions";
import routers from "@/router/routers";

export default {
  name: "OrderPage",
  components: {
    Pagination
  },
  data() {
    return {
      createTime: [],
      params: {
        ...this.initialParams // 初始化参数
      },
      initialParams:{
        platformId: '',
        productId: '',
        orderNo: '',
        customerName: '',
        status: '',
        department: '',
        salesmanName: '',
        beginTime: "",
        endTime: "",
      },
      selectTime: [],
      username: store.state.userInfo.username,
      tableData: [],
      rowDataObj: {},
      platformList: [],
      productList: [],
      options: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      }
    }
  },
  watch: {
    'createTime': {
      handler(val) {
        if (val) {
          this.params.beginTime = val[0] + " 00:00:00"
          this.params.endTime = val[1] + " 23:59:59"
        } else {
          this.params.beginTime = ''
          this.params.endTime = ''
        }
      }
    },
    'params.platformId': {
      handler(val) {
        this.params.productId = '';
        if (val) {
          this.getProductList()
        }
      }
    }
  },
  mounted() {
    this.getPlatformList()
    this.getProductList()
    this.getPositionsTree()
    this.getPageList();
  },
  methods: {
    hasPer,
    getPageList() {
      getOrderList({...this.params}).then(res => {
        this.tableData = res.records
        this.params.total = res.total
        this.params.current = 1;
        this.params.size = res.size
      })
    },
    getPlatformList() {
      getPlatformList().then(res => {
        this.platformList = res
      })
    },
    getProductList() {
      getProductList({platformId: this.params.platformId}).then(res => {
        this.productList = res
      })
    },
    getPositionsTree() {
      getPositionsTree({}).then(res => {
        this.options = res
      })
    },
    handleChange(selectedValue) {
      this.params.department = selectedValue.slice(-1)[0];
    },
    viewRow(row) {
      //  将当前打开的菜单添加到已打开列表中
      store.dispatch('addTabAction', {name: "订单查看", path: `/order/view`, params: {orderNo: row.orderNo}})
      //  将激活菜单改成选中的菜单
      store.dispatch('activeIndexAction', "订单查看")
      routers.push({name: "订单查看", params: {orderNo: row.orderNo, isApproval: false}})
    },
    // 重置方法
    resetSearch() {
      // 重置表单参数
      this.params = { ...this.initialParams }
      // 重置日期选择
      this.createTime = null
      // 如果需要清空级联选择器的缓存数据
      this.$refs.cascader && this.$refs.cascader.clearCheckedNodes()
      // 自动触发查询
      this.getPageList()
    }
  }
}
</script>

<style scoped>
.el-table{
  height: calc(100vh - 210px);
  max-height: calc(100vh - 210px);
  overflow: auto;
}
.w-full {
  width: 100%;
}
.mt-4 {
  margin-top: 1rem;
}
/* 表格容器 */
.table-container {
  flex: 1;
  max-height: 700px; /* 最小高度保障 */
  display: flex;
  flex-direction: column;
  background: #fff;
  margin-top: 5px;
}
</style>
